import { useDispatch } from 'react-redux'
import { useMemo } from 'react'
import { bindActionCreators } from '@reduxjs/toolkit'
import { actionCreators } from '@/store/actionsCreators'

export const useActions = () => {
  const dispatch = useDispatch()
  return useMemo(() => bindActionCreators(actionCreators, dispatch), [dispatch])
}
